/**
 * Scheduling hint only — never an authorisation decision. The server is the only verifier.
 * Base64url-decode the payload; never verify a signature; never log the token.
 */
export type TokenExpiry = { state: 'ok'; expiresAtMs: number } | { state: 'absent' } | { state: 'unreadable' };

function decodePayload(token: string): Record<string, unknown> | null {
  const parts = token.split('.');
  if (parts.length < 2) {
    return null;
  }
  try {
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    const json = typeof atob === 'function' ? atob(padded) : Buffer.from(padded, 'base64').toString('utf8');
    return JSON.parse(json);
  } catch (_) {
    return null;
  }
}

export function readTokenExpiry(token?: string | null): TokenExpiry {
  if (token == null || token === '') {
    return { state: 'absent' };
  }
  const payload = decodePayload(token);
  if (!payload || typeof payload.exp !== 'number') {
    return { state: 'unreadable' };
  }
  return { state: 'ok', expiresAtMs: payload.exp * 1000 };
}
